import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import styles from './VideoPreviewModal.scss';

export const VideoPreviewModal = ({ isOpen, onClose, vidUrl }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      classes={{ paper: styles.dialog_root }}
    >
      <video controls autoPlay>
        <track default kind="captions" />
        <source src={vidUrl} type="video/mp4" />
      </video>
    </Dialog>
  );
};

VideoPreviewModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  vidUrl: PropTypes.string.isRequired,
};
